import { useEffect } from 'react';
import { trackEvent } from './analytics';

const THRESHOLDS = [25, 50, 75, 100];

// Fires a GA4 `scroll_depth` event once per threshold per page view.
// Pass null/undefined as the label to disable (e.g. the embed route).
// The effect re-runs when `locationLabel` changes, re-arming thresholds on
// every SPA route change.
export const useScrollDepth = (locationLabel) => {
  useEffect(() => {
    if (!locationLabel) return undefined;

    const fired = new Set();
    let ticking = false;

    const check = () => {
      ticking = false;
      const scrollable = document.documentElement.scrollHeight - window.innerHeight;
      // Pages too short to scroll count as fully read.
      const pct = scrollable <= 0
        ? 100
        : Math.min(100, Math.round((window.scrollY / scrollable) * 100));
      THRESHOLDS.forEach((t) => {
        if (pct >= t && !fired.has(t)) {
          fired.add(t);
          trackEvent('scroll_depth', {
            percent_scrolled: t,
            location: locationLabel,
            app: 'ge_negerisembilan',
          });
        }
      });
    };

    const onScroll = () => {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(check);
      }
    };

    check(); // catch short pages / initial position
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [locationLabel]);
};
